import React, { forwardRef } from 'react';

const SIZE_CLASS = {
  sm: 'w-8 h-8 rounded-xl',
  md: 'w-10 h-10 rounded-xl',
  lg: 'w-12 h-12 rounded-2xl',
  xl: 'w-16 h-16 rounded-2xl',
};

const GRADIENT_PRESET = {
  insight: 'bg-gradient-to-r from-apple-blue to-critic-insight-end',
  insightBr: 'bg-gradient-to-br from-apple-blue/30 to-critic-insight-mid/20',
  orange: 'bg-gradient-to-r from-apple-orange to-apple-yellow',
  indigo: 'bg-gradient-to-r from-apple-indigo to-apple-purple',
  green: 'bg-gradient-to-r from-apple-green to-apple-teal',
  purple: 'bg-gradient-to-r from-apple-purple to-apple-pink',
  lockBlue: 'bg-gradient-to-r from-apple-blue/30 to-apple-purple/30 border border-apple-blue/50',
  lockOrange: 'bg-gradient-to-r from-apple-orange/30 to-apple-yellow/30 border border-apple-orange/50',
  lockGreen: 'bg-gradient-to-r from-apple-green/30 to-apple-teal/30 border border-apple-green/50',
  lockPurple: 'bg-gradient-to-r from-apple-purple/30 to-apple-pink/30 border border-apple-purple/50',
  lockIndigo: 'bg-gradient-to-r from-apple-indigo/30 to-apple-purple/30 border border-apple-indigo/50',
};

/**
 * Gradient icon container used in section headers and lock overlays.
 *
 * @param {object} props
 * @param {'sm'|'md'|'lg'|'xl'} [props.size='lg']
 * @param {keyof GRADIENT_PRESET|string} [props.gradient='insight'] — preset key or raw Tailwind classes
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
const IconTile = forwardRef(function IconTile(
  { size = 'lg', gradient = 'insight', className = '', children, ...rest },
  ref
) {
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.lg;
  const gradientClass = GRADIENT_PRESET[gradient] || gradient;
  return (
    <div
      ref={ref}
      className={`${sizeClass} ${gradientClass} flex items-center justify-center flex-shrink-0 ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
});

export default IconTile;
